import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var FeatureToggleName;
(function (FeatureToggleName) {
    FeatureToggleName["MANUAL_POST_INVOICING"] = "MANUAL_POST_INVOICING";
    FeatureToggleName["ONLINE_VALIDATION"] = "ONLINE_VALIDATION";
    FeatureToggleName["SCREEN_RESTRICTIONS"] = "SCREEN_RESTRICTIONS";
    FeatureToggleName["CUSTOMER_INVOICE_REFERENCE"] = "CUSTOMER_INVOICE_REFERENCE";
    FeatureToggleName["ACCOUNTING_NUMBER"] = "ACCOUNTING_NUMBER";
    FeatureToggleName["POSITION_OVERWRITING"] = "POSITION_OVERWRITING";
    FeatureToggleName["BRIEFING_EML"] = "BRIEFING_EML";
    FeatureToggleName["DEFAULT_SERVICE_PRODUCT_DISCOUNT"] = "DEFAULT_SERVICE_PRODUCT_DISCOUNT";
    FeatureToggleName["DEFAULT_ONLINE_LINE_ITEMS_MAX_CAPACITY"] = "DEFAULT_ONLINE_LINE_ITEMS_MAX_CAPACITY";
    FeatureToggleName["REACH"] = "REACH";
    FeatureToggleName["ONLINE_POSITIONS_OVERBOOKING_VALIDATION"] = "ONLINE_POSITIONS_OVERBOOKING_VALIDATION";
    FeatureToggleName["EXISTING_CUSTOMERS"] = "EXISTING_CUSTOMERS";
    FeatureToggleName["POSTRON_MOBILE_IN_APP_DISPLAY_SUPPRESSION"] = "POSTRON_MOBILE_IN_APP_DISPLAY_SUPPRESSION";
    FeatureToggleName["POSTRON_MOBILE_IN_APP_DISPLAY_HIDING"] = "POSTRON_MOBILE_IN_APP_DISPLAY_HIDING";
    FeatureToggleName["DYNAMIC_CAMPAIGN_MANAGEMENT_GROSS"] = "DYNAMIC_CAMPAIGN_MANAGEMENT_GROSS";
    FeatureToggleName["DYNAMIC_DOOH"] = "DYNAMIC_DOOH";
    FeatureToggleName["SUPPORT_LIVESYSTEMS_API_V2"] = "SUPPORT_LIVESYSTEMS_API_V2";
    FeatureToggleName["DYNAMIC_DOOH_POSITIONS"] = "DYNAMIC_DOOH_POSITIONS";
    FeatureToggleName["DYNAMIC_DOOH_POSITIONS_RENAME"] = "DYNAMIC_DOOH_POSITIONS_RENAME";
    FeatureToggleName["DYNAMIC_DOOH_POSITIONS_CLONE"] = "DYNAMIC_DOOH_POSITIONS_CLONE";
    FeatureToggleName["LAST_MINUTE_DISCOUNT"] = "LAST_MINUTE_DISCOUNT";
    FeatureToggleName["REPEAT_DISCOUNT"] = "REPEAT_DISCOUNT";
    FeatureToggleName["EXTENSION_DISCOUNT"] = "EXTENSION_DISCOUNT";
    FeatureToggleName["PUSH_TO_LOGISTICS"] = "PUSH_TO_LOGISTICS";
    FeatureToggleName["REDUCE_LAST_MINUTE_DISCOUNT"] = "REDUCE_LAST_MINUTE_DISCOUNT";
    FeatureToggleName["ZERO_LAST_MINUTE_DISCOUNT"] = "ZERO_LAST_MINUTE_DISCOUNT";
    FeatureToggleName["DEADLINE_CALCULATION"] = "DEADLINE_CALCULATION";
    FeatureToggleName["LOGISTICS_NOTIFICATIONS"] = "LOGISTICS_NOTIFICATIONS";
    FeatureToggleName["PATH_API"] = "PATH_API";
    FeatureToggleName["TEMPORARY_ACCESS_MANAGEMENT"] = "TEMPORARY_ACCESS_MANAGEMENT";
    FeatureToggleName["DATA_PRODUCT_POSITIONS"] = "DATA_PRODUCT_POSITIONS";
})(FeatureToggleName || (FeatureToggleName = {}));
